export const mapStudyToOption = (study) => ({
  value: study.studyId,
  title: study.name,
});

export const mapCountryToOption = (country) => ({
  value: country.countryId,
  title: country.name,
});

export const mapStudiesToOptions = (items = []) => items.map(mapStudyToOption);

export const mapCountriesForStudy = (items = [], studyId) => {
  const study = items.find((item) => item.studyId === studyId);
  const countries = study?.countries ?? [];
  return countries.map(mapCountryToOption);
};
